import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="employer-allowances"
export default class extends Controller {
  static targets = [
    'yearSelect',
    'allowanceDiv',
  ]

  declare readonly yearSelectTarget: HTMLSelectElement
  declare readonly allowanceDivTargets: HTMLElement[]

  connect () {
    this.yearSelectTarget.addEventListener('change', this.switchPlanYear)
  }

  switchPlanYear = (): void => {
    const selectedYear = this.yearSelectTarget.value
    this.allowanceDivTargets.forEach(function (allowanceDiv) {
      if (allowanceDiv.id === selectedYear) {
        allowanceDiv.classList.remove('hidden')
      } else {
        allowanceDiv.classList.add('hidden')
      }
    })
  }
}
